import {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from "resize-observer-polyfill";
const resizeObserverOrPolyfill =  ResizeObserver;

const useResizeObserver = (element) => {
  const [size, setSize] = useState({width: 0, height: 0});
  const current = element && element.current;

  const observer = useRef(null);

  useEffect(() => {
    // if we are already observing old element
    if (observer && observer.current && current) {
      observer.current.unobserve(current);
    }

    observer.current = new resizeObserverOrPolyfill((e) => {
      console.log('Observe stuff', e);
      setSize({
        width: e[0].contentRect.width,
        height: e[0].contentRect.height
      });

    });
    observe();

    return () => {
      if (observer && observer.current && element &&
        element.current) {
        observer.current.unobserve(element.current);
      }
    };
  }, [current]);

  const observe = () => {
    if (element && element.current && observer.current) {
      observer.current.observe(element.current);
    }
  };

  console.log('Returning size', size)
  return size
};

useResizeObserver.propTypes = {
  element: PropTypes.object
};

export default useResizeObserver;